import { useMemo } from 'react'
import { useSpotSwapRecommendTokens } from '~/state/dex/hooks'
import TokenRecommendationsBox from '~/components/TokenListModal/components/TokenRecommendationsBox'
import { Mainnet, Sepolia } from '~/model/chain/ethereum'
import { ENV } from '~/constants/env'
import { compareAddress } from '~/utils/token'

interface TokenRecommendationsProps {
  selectedChainId: number | null
  onTokenSelected: (token: SpotSwapToken) => void
}

const TokenRecommendations: React.FC<TokenRecommendationsProps> = ({
  selectedChainId,
  onTokenSelected,
}) => {
  const allRecommendTokens = useSpotSwapRecommendTokens()

  const isSelectedAll = selectedChainId === null
  const isSelectedMainnet = selectedChainId === Mainnet.chainId

  const recommendTokens = useMemo(() => {
    let tokens = undefined
    if (isSelectedAll) {
      const isDev = ENV.development || ENV.local
      const firstArr = []
      const resetArr = []
      const firstChainId = isDev ? Sepolia.chainId : Mainnet.chainId

      allRecommendTokens.forEach((token) => {
        if (token.chainId === firstChainId) {
          firstArr.push(token)
        } else {
          resetArr.push(token)
        }
      })
      tokens = [...firstArr.slice(0, 3), ...resetArr.slice(0, 4)]
    } else {
      tokens = allRecommendTokens.filter(
        (token) => token.chainId === selectedChainId,
      )
    }

    let result = tokens
    if (isSelectedAll || isSelectedMainnet) {
      result = tokens?.filter(({ address, chainId }) => {
        // DUSD/USDC quotes come from v5 RFQv1, but the current web does not support v5 RFQv1, so the DUSD token should be removed from the recommendation position.
        const isDUSD =
          chainId === Mainnet.chainId &&
          compareAddress(address, '0x3581f76498675912d2effb9def320464f49a3538')
        return !isDUSD
      })
    }
    return result
  }, [ENV, allRecommendTokens, selectedChainId])

  return (
    <TokenRecommendationsBox
      recommendTokens={recommendTokens}
      onTokenSelect={onTokenSelected}
      showNetworkBadge={isSelectedAll}
    />
  )
}

export default TokenRecommendations
